import axios from "axios";
import { LegacyIdConfigParams, LegacyIdConfigResponse } from "./legacyConfig.shemas";
import { ResponseList } from "../../models/common/Response";

export async function retrieveLegacyIdConfig(params: LegacyIdConfigParams) {
    return await axios.get<ResponseList<LegacyIdConfigResponse>>('/v1/legacy/report', {
        params: params,
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
        }
    })
}